var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81274 4.24839C7.21274 4.54839 7.31276 5.24838 7.01276 5.64838C7.01276 5.74838 6.91274 5.74838 6.81274 5.84838L2.41272 9.24839C2.01272 9.54839 1.31276 9.54839 1.01276 9.04839C0.912756 8.84839 0.812744 8.64838 0.812744 8.44838V1.54839C0.812744 0.948389 1.21274 0.548389 1.81274 0.548389C2.01274 0.548389 2.21272 0.648386 2.41272 0.748386L6.81274 4.24839Z",
    fill: "#616770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleLeft);
export default __webpack_public_path__ + "static/media/triangle-left.fad997f60db4ed05d1a575cbd2f8b4f3.svg";
export { ForwardRef as ReactComponent };